import React, { useState } from 'react';
import api from '../api';
import { CheckCircle2, XCircle, AlertCircle, Circle } from 'lucide-react';

const SLIDES = [
  {
    title: 'IsItTrueNow',
    body: 'The place where claims get tested. Post any claim or article. The community responds. AI analyzes every argument for logic and evidence.',
    cta: 'Next',
  },
  {
    title: 'Every argument gets a verdict',
    body: "Verified means it's standing. Invalidated means it's been countered. The AI is the referee — it never takes sides, only evaluates logic.",
    cta: 'Next',
    extra: (
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginTop: 24 }}>
        {[
          { color: 'var(--color-verified)', bg: 'var(--color-verified-bg)', border: 'var(--color-verified-border)', label: 'Verified', Icon: CheckCircle2 },
          { color: 'var(--color-invalidated)', bg: 'var(--color-invalidated-bg)', border: 'var(--color-invalidated-border)', label: 'Invalidated', Icon: XCircle },
          { color: 'var(--color-disputed)', bg: 'var(--color-disputed-bg)', border: 'var(--color-disputed-border)', label: 'Disputed', Icon: AlertCircle },
          { color: 'var(--color-new)', bg: 'var(--color-new-bg)', border: 'var(--color-new-border)', label: 'New', Icon: Circle },
        ].map(v => (
          <div key={v.label} style={{
            background: v.bg,
            border: `1px solid ${v.border}`,
            color: v.color,
            borderRadius: 8,
            padding: '6px 14px',
            fontSize: 13,
            fontWeight: 600,
            fontFamily: 'var(--font-body)',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}>
            <v.Icon size={14} />
            {v.label}
          </div>
        ))}
      </div>
    ),
  },
  {
    title: 'Anyone can participate',
    body: 'Make an argument, vote on one, or just follow the debate. Logic wins here, not volume.',
    cta: 'Get Started',
  },
];

export default function OnboardingModal({ onComplete }) {
  const [slide, setSlide] = useState(0);
  const [loading, setLoading] = useState(false);
  const current = SLIDES[slide];

  const handleCta = async () => {
    if (slide < SLIDES.length - 1) {
      setSlide(s => s + 1);
    } else {
      setLoading(true);
      try {
        await api.patch('/auth/onboarding');
      } catch (_) {}
      onComplete();
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 2000,
      background: 'rgba(15, 25, 35, 0.6)',
      backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16,
    }}>
      <div style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        borderRadius: 16,
        padding: '40px 36px',
        maxWidth: 480,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.15)',
      }}>
        {/* Progress dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 32 }}>
          {SLIDES.map((_, i) => (
            <div key={i} style={{
              width: i === slide ? 20 : 6,
              height: 6,
              borderRadius: 3,
              background: i === slide ? 'var(--color-brand)' : 'var(--color-border)',
              transition: 'width 0.2s ease, background 0.2s ease',
            }} />
          ))}
        </div>

        <h2 style={{
          fontFamily: 'var(--font-display)',
          fontSize: slide === 0 ? 32 : 24,
          fontWeight: 700,
          color: 'var(--color-text-primary)',
          marginBottom: 14,
          lineHeight: 1.2,
        }}>
          {current.title}
        </h2>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: 15,
          color: 'var(--color-text-secondary)',
          lineHeight: 1.7,
        }}>
          {current.body}
        </p>

        {current.extra && current.extra}

        <button
          onClick={handleCta}
          disabled={loading}
          style={{
            marginTop: 32,
            padding: '12px 32px',
            background: 'var(--color-brand)',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontFamily: 'var(--font-body)',
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
            width: '100%',
            transition: 'background 0.15s ease',
          }}
          onMouseEnter={e => (e.currentTarget.style.background = 'var(--color-brand-hover)')}
          onMouseLeave={e => (e.currentTarget.style.background = 'var(--color-brand)')}
        >
          {loading ? 'Starting…' : current.cta}
        </button>
      </div>
    </div>
  );
}
